import type { TourDefinition } from '../types';
import { TOUR_IDS } from '../types';

export const entryFeePrizeTour: TourDefinition = {
  id: TOUR_IDS.ENTRY_FEE_PRIZE,
  steps: [
    {
      target: '[data-tour="entry-fee-header"]',
      titleKey: 'entryFeePrize.welcome.title',
      contentKey: 'entryFeePrize.welcome.content',
      placement: 'center',
      skipBeacon: true,
    },
    {
      target: '[data-tour="entry-fee-pool-type"]',
      titleKey: 'entryFeePrize.poolType.title',
      contentKey: 'entryFeePrize.poolType.content',
      placement: 'top-start',
      disableFlip: true,
      offset: 4,
      topScrollRoom: 220,
      floatingOptions: {
        shiftOptions: {
          padding: { top: 8, bottom: 24, left: 16, right: 16 },
          mainAxis: false,
          crossAxis: true,
          rootBoundary: 'viewport',
        },
      },
      switchTab: '1',
    },
    {
      target: '[data-tour="entry-fee-config"]',
      titleKey: 'entryFeePrize.configuration.title',
      contentKey: 'entryFeePrize.configuration.content',
      placement: 'top-start',
      disableFlip: true,
      offset: 4,
      topScrollRoom: 220,
      floatingOptions: {
        shiftOptions: {
          padding: { top: 8, bottom: 24, left: 16, right: 16 },
          mainAxis: false,
          crossAxis: true,
          rootBoundary: 'viewport',
        },
      },
      switchTab: '1',
    },
    {
      target: '[data-tour="entry-fee-commission"]',
      titleKey: 'entryFeePrize.commission.title',
      contentKey: 'entryFeePrize.commission.content',
      placement: 'top-start',
      disableFlip: true,
      offset: 4,
      topScrollRoom: 220,
      floatingOptions: {
        shiftOptions: {
          padding: { top: 8, bottom: 24, left: 16, right: 16 },
          mainAxis: false,
          crossAxis: true,
          rootBoundary: 'viewport',
        },
      },
      switchTab: '1',
    },
    {
      target: '[data-tour="entry-fee-next"]',
      titleKey: 'entryFeePrize.next.title',
      contentKey: 'entryFeePrize.next.content',
      placement: 'top-end',
      disableFlip: true,
      offset: 4,
      switchTab: '1',
    },
    {
      target: '[data-tour="entry-fee-distribution"]',
      titleKey: 'entryFeePrize.distribution.title',
      contentKey: 'entryFeePrize.distribution.content',
      placement: 'top',
      offset: 4,
      switchTab: '2',
    },
  ],
};
